import { useTheme, useColorMode } from "@chakra-ui/react";

export function useMyTheme(prop: string) {
  const theme = useTheme();
  const { colorMode } = useColorMode();

  return theme.appColors[colorMode][prop];
}
